<template>
  <div class="my-10">
    <div class="px-4 flex flex-col justify-center items-center space-y-4">
      <h1 class="text-3xl font-bold text-center">{{ __("Edit user") }}</h1>

      <inertia-link
          v-if="user.deleted_at !== null"
          :href="route('users.restore', {id: user.id})" method="POST" class="inline-flex items-center justify-center flex-shrink-0 px-4 py-2 text-white rounded bg-coral-400 hover:bg-coral-300">
        {{ __("Restore user") }}
      </inertia-link>
    </div>

    <div class="bg-white p-4 shadow-md mt-10 ">
      <div class="max-w-md w-full mx-auto my-10 flex flex-col items-center">
        <form @submit.prevent="submitForm" class="w-full">
          <div>
            <text-input v-model="form.name" :data-error="error('name')" class="w-full pb-8" :label="__('Name')"/>
            <text-input v-model="form.email" :data-error="error('email')" class="w-full pb-8" :label="__('Label')"/>
            <text-input v-model="form.reference_id" :data-error="error('reference_id')" class="w-full pb-8" :label="__('Reference ID')"/>

            <div class="flex items-center mb-8">
              <input id="is-supervisor" v-model="form.is_supervisor" class="border focus:ring focus:border-coral-400" type="checkbox">
              <label class="w-full block text-gray-400 ml-3 text-lg" for="is-supervisor">
                {{ __('Supervisor') }}
              </label>
            </div>

            <select-input v-model="form.role_id" :data-error="error('role_id')" class="w-full pb-8" :label="__('Role')">
              <option v-for="role in roles" :key="role.id" :value="role.id">{{ role.name }}</option>
            </select-input>

            <div class="mb-8">
              <label class="block text-gray-400 mb-6">Dealerships: </label>
              <div v-for="dealership in dealerships" :key="dealership.id" class="flex items-center mb-4">
                <input v-model="form.dealership_ids" :id="'dealership-' + dealership.id" ref="checkbox" class="border focus:ring focus:border-coral-400" type="checkbox" :value="dealership.id">
                <label class="w-full block text-gray-400 ml-3 text-lg" :for="'dealership-' + dealership.id">
                  {{ dealership.name }}
                </label>
              </div>
            </div>

            <text-input v-model="form.password" :data-error="error('password')" class="w-full pb-8" type="password" :label="__('Password')"/>
            <text-input v-model="form.password_confirmation" :data-error="error('password_confirmation')" class="w-full pb-8" type="password" :label="__('Password confirmation')"/>
          </div>

          <div class="flex flex-col items-center">
            <image-input v-model="form.profileImage" :image-url="user.profile_image_url" :show-delete-button="user.profile_image_url !== $page.props.config.defaultProfileImageUrl" :data-error="error('profileImage')" @deleteImage="deleteProfileImage()" class="w-full" type="file"/>
          </div>

          <div class="flex justify-center items-center mt-10">
            <loading-button :loading="sendingForm" class="btn-primary" type="submit">
              {{ __("Save") }}
            </loading-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import Layout from '@/Shared/Layout';
  import TextInput from '@/Shared/TextInput';
  import ImageInput from '@/Shared/ImageInput';
  import LoadingButton from '@/Shared/LoadingButton';
  import SelectInput from '@/Shared/SelectInput';
  import Icon from '@/Shared/Icon';

  export default {
    layout: Layout,
    metaInfo() {
      return {
        title: this.__("Edit user")
      }
    },
    props: {
      roles: Array,
      dealerships: Array,
      user: Object
    },
    data() {
      return {
        form: {
          name: this.user.name,
          email: this.user.email,
          reference_id: this.user.reference_id || '',
          is_supervisor: !!this.user.is_supervisor,
          role_id: this.user.role.id,
          password: null,
          password_confirmation: null,
          profileImage: null,
          dealership_ids: this.user.dealership_ids
        },
        sendingForm: false,
      }
    },
    components: {
      Layout,
      TextInput,
      ImageInput,
      LoadingButton,
      Icon,
      SelectInput
    },
    methods: {
      submitForm() {
        this.sendingForm = true;
        let data = new FormData();
        data.append('name', this.form.name || '');
        data.append('email', this.form.email || '');
        data.append('reference_id', this.form.reference_id || '');
        data.append('is_supervisor', this.form.is_supervisor ? '1' : '0');
        data.append('role_id', this.form.role_id || '');
        data.append('password', this.form.password || '');
        data.append('password_confirmation', this.form.password_confirmation || '');
        data.append('profileImage', this.form.profileImage || '');
        data.append('_method', 'put');

        this.form.dealership_ids.forEach((id) => {
          data.append('dealership_ids[]', id);
        });

        this.$inertia.post(this.route('users.update', {'user': this.user.id}), data)
          .then(() => {
            this.sendingForm = false;
          });
      },
      deleteProfileImage() {
        this.$inertia.delete(this.route('profileImage.destroy', {'user': this.user.id}));
      },
    }
  }
</script>
